import { render, staticRenderFns } from "./KodeLokasi.vue?vue&type=template&id=b5c5ff84&"
import script from "./KodeLokasi.vue?vue&type=script&lang=js&"
export * from "./KodeLokasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports